var React = require('react');

function Large2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m2000 7500v-500h-500-500v-1000-1000h1000 1000v500 500h1000 1000v-500-500h-500-500v-500-500h-500-500v-500-500h-500-500v-500-500h-500-500v-1000-1000h3000 3000v1000 1000h-1000-1000v500 500h500 500v500 500h500 500v1500 1500h-500-500v500 500h-2000-2000z","transform":"matrix(.1 0 0 -.1 0 800)"}));
}

Large2.defaultProps = {"height":"800pt","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 800 800","width":"800pt"};

module.exports = Large2;

Large2.default = Large2;
